<template>
  <v-container fluid class="inventorycount-add-page mt-3 mx-1">
    <v-row>
      <v-col cols="12">
        <v-stepper v-model="step" class="transparent elevation-0">
          <v-card class="mb-5">
            <v-stepper-header >
              <v-stepper-step :complete="step > 1" step="1">Inventory Count</v-stepper-step>
              <v-divider></v-divider>
              <v-stepper-step :complete="step > 2" step="2">Items</v-stepper-step>
            </v-stepper-header>
          </v-card>

          <v-card>
            <v-stepper-items>
              <v-stepper-content step="1">
                <v-card>
                  <v-row>
                    <v-col cols="12" md="3">
                      <v-form>
                        <p class="text-h5">New Inventory Count</p>
                        <v-select
                          class="mb-4"
                          :items=counttype
                          v-model="inventorycount.counttype"
                          v-bind:error="error == 'counttype'"
                          outlined
                          dense
                          placeholder="Type"
                          persistent-hint
                          single-line hint="Please choose the count type">
                        </v-select>
                        <v-menu
                          ref="menu_countdate"
                          v-model="menu_countdate"
                          :close-on-content-click="false"
                          :return-value.sync="inventorycount.countdate"
                          transition="scale-transition"
                          offset-y
                          min-width="auto"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              outlined
                              dense
                              persistent-hint
                              class="mb-4"
                              v-model="inventorycount.countdate"
                              label="Count Date"
                              v-bind="attrs"
                              v-bind:value="inventorycount.countdate"
                              v-bind:error="error == 'countdate'"
                              v-on="on"
                              single-line hint="Please choose the count date">
                            ></v-text-field>
                          </template>
                          <v-date-picker
                            v-model="inventorycount.countdate"
                            no-title
                            scrollable
                          >
                            <v-spacer></v-spacer>
                            <v-btn
                              text
                              color="primary"
                              @click="menu_countdate = false"
                            >
                              Cancel
                            </v-btn>
                            <v-btn
                              text
                              color="primary"
                              @click="$refs.menu_countdate.save(inventorycount.countdate)"
                            >
                              OK
                            </v-btn>
                          </v-date-picker>
                        </v-menu>
                        <v-select
                          class="mb-4"
                          :items="locations.map(x => {
                            return {text: x.locationname, value: x._id};
                            })"
                          v-model="inventorycount.locationid"
                          v-bind:error="error == 'locationid'"
                          outlined
                          dense
                          placeholder="Location"
                          persistent-hint
                          single-line hint="Please choose the location">
                        </v-select>
                      </v-form>
                    </v-col>                                      
                  </v-row>
                  <v-row justify="center">
                    <v-col cols="12" md="12">
                      <div class="d-flex justify-center">
                        <v-btn
                            to="/inventorycount/list"
                            replace
                            outlined
                            color="primary"
                        >
                          Cancel
                        </v-btn>
                        <v-spacer></v-spacer>
                          <v-btn
                            class="button-shadow"
                            color="primary"
                            @click="checkError">
                            Next
                          </v-btn>
                      </div>
                    </v-col>
                  </v-row>
                </v-card>
              </v-stepper-content>
              <v-stepper-content step="2">
                <v-card>
                  <v-row>
                    <v-col md="10">
                      <p class="text-h5">Items</p>
                    </v-col>
                    <v-col md="2" align="right">
                      <v-btn
                        class="button-shadow"
                        color="success"
                        @click="isAddTransaction=true;  add_transaction={};">
                        Add
                      </v-btn>
                    </v-col>
                  </v-row>
                  <v-data-table
                    :headers="headers"
                    :items="transactions"
                    :items-per-page="500"
                    :footer-props="footer"
                    class="elevation-0"
                  >
                    <template v-slot:item.itemimage="{ item }"> 
                      <v-img
                        v-bind:lazy-src="item.itemimage"
                        min-width=50
                        max-width=100
                        v-bind:src="item.itemimage"
                      ></v-img>
                    </template>
                    <template v-slot:item.itemquantity="{ item }">
                      {{ Number(item.itemquantity || 0).toFixed(2) }}
                    </template>
                    <template v-slot:item.actions="{ item }">
                      <v-btn icon color="primary" @click="editTransactionDialog(item)">
                        <v-icon>mdi-pencil-outline</v-icon>
                      </v-btn>
                      <v-btn icon color="primary" @click="deleteTransaction(item)">
                        <v-icon>mdi-close</v-icon>
                      </v-btn>
                    </template>
                  </v-data-table>
                  <v-row justify="center">
                    <v-col cols="12" md="12">
                        <div class="d-flex justify-center">
                          <v-btn
                            outlined
                            color="primary"
                            @click="step = 1"
                          >
                            Back
                          </v-btn>
                          <v-spacer></v-spacer>
                          <v-btn
                            :loading="isReceiving"
                            class="button-shadow"
                            color="primary"
                            @click="insertInventoryCount()">
                            Save
                          </v-btn>
                        </div>
                    </v-col>
                  </v-row>
                </v-card>
              </v-stepper-content>
            </v-stepper-items>
          </v-card>
        </v-stepper>
      </v-col>
    </v-row>
    <div>
      <v-dialog
          v-model="isAddTransaction"
          persistent
          width="600px"
          max-width="600px"
        >
          <v-card>
            <v-card-title>
              <span class="text-h5">Add Transaction</span>
            </v-card-title>
            <v-card-text>
              <v-container>
                <v-row>

                </v-row>
                <v-row>
                  <v-col cols="12" md="4">
                    <v-select
                      class="mb-4"
                      :items="brands.filter(brand=>brand.brandtype=='Brand').map(x => {
                        return {text: x.brandname, value: x._id};
                      })"
                      v-model="add_transaction.brandid"
                      v-bind:error="errorindex == 2"
                      dense
                      placeholder="Brand"
                      persistent-hint
                      single-line hint="Brand">
                    </v-select>
                  </v-col>
                  <v-col cols="12" md="8">
                    <v-select
                      class="mb-4"
                      :items="items.filter(item=>item.brandid == add_transaction.brandid).map(x => {
                        return {text: x.itemname, value: x._id};
                        })"
                      v-model="add_transaction.itemid"
                      v-bind:error="errorindex == 0"
                      dense
                      placeholder="Item"
                      persistent-hint
                      single-line hint="Item">
                    </v-select>
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-text-field
                      v-model="add_transaction.itemqty"
                      class="mb-4"
                      dense
                      placeholder="Qty"
                      persistent-hint
                      type="number"
                      oninput="if(this.value < 1) this.value = 1;"
                      single-line hint="Qty">
                    </v-text-field>
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-text-field
                      v-model="add_transaction.itempcs"
                      class="mb-4"
                      dense
                      placeholder="Pcs"
                      persistent-hint
                      single-line hint="Pcs">
                    </v-text-field>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="blue darken-1"
                text
                @click="isAddTransaction=false; add_transaction={}"
              >
                Close
              </v-btn>
              <v-btn
                color="blue darken-1"
                text
                @click="addTransaction"
              >
                Save
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      <v-dialog
        v-model="isEditTransaction"
        persistent
        width="600px"
        max-width="600px"
      >
        <v-card>
          <v-card-title>
            <span class="text-h5">Edit Transaction</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>

              </v-row>
              <v-row>
                <v-col cols="12" md="4">
                  <v-select
                    class="mb-4"
                    :items="brands.filter(brand=>brand.brandtype=='Brand').map(x => {
                      return {text: x.brandname, value: x._id};
                    })"
                    v-model="edit_transaction.brandid"
                    v-bind:error="errorindex == 2"
                    dense
                    placeholder="Brand"
                    persistent-hint
                    single-line hint="Brand">
                  </v-select>
                </v-col>
                <v-col cols="12" md="8">
                  <v-select
                    class="mb-4"
                    :items="items.filter(item=>item.brandid == edit_transaction.brandid).map(x => {
                      return {text: x.itemname, value: x._id};
                      })"
                    v-model="edit_transaction.itemid"
                    v-bind:error="errorindex == 0"
                    dense
                    placeholder="Item"
                    persistent-hint
                    single-line hint="Item">
                  </v-select>
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field
                    v-model="edit_transaction.itemqty"
                    class="mb-4"
                    dense
                    placeholder="Qty"
                    persistent-hint
                    type="number"
                    oninput="if(this.value < 1) this.value = 1;"
                    single-line hint="Quantity">
                  </v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field
                    v-model="edit_transaction.itempcs"
                    class="mb-4"
                    dense
                    placeholder="Pcs"
                    persistent-hint
                    single-line hint="Pcs">
                  </v-text-field>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="blue darken-1"
              text
              @click="isEditTransaction=false; edit_transaction={}"
            >
              Close
            </v-btn>
            <v-btn
              color="blue darken-1"
              text
              @click="editTransaction"
            >
              Save
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </v-container>
</template>

<script>
import {mapActions, mapState} from "vuex";
import router from '@/Routes';

export default {
  data () {
    return {
      headers: [
        { text: 'Image', value: 'itemimage', width: '10%' },
        { text: 'Name', value: 'itemname' },
        { text: 'Qty', value: 'itemqty', width: '10%'},
        { text: 'Pcs', value: 'itempcs', width: '10%'},
        { text: 'Quantity', value: 'itemquantity', width: '10%'},
        { text: 'Actions', value: 'actions', sortable: false, width: '10%' },
      ],
      step: 1,
      isAddTransaction: false,
      isEditTransaction: false,
      brandid: undefined,

      
      menu_countdate: false,
      error: undefined,
      haserror: false,
      errorindex: undefined,
      inventorycount: {},
      add_transaction: {},
      edit_transaction: {},
      change_transaction: {},
      transactions: [],
      footer: {'items-per-page-options': [500, 1000, 5000]},
      counttype: ['Inventory Count'],
      
    }
  },
  computed: {
    ...mapState('Brand', ['brands']),
    ...mapState('Item', ['items']),
    ...mapState('Location', ['locations']),
    ...mapState('InventoryCount', ['isReceiving']),
  },
  methods: {
    ...mapActions('Brand', ['getBrandsRequest']),
    ...mapActions('Item', ['getItemsRequest']),
    ...mapActions('Location', ['getLocationsRequest']),
    ...mapActions('InventoryCount', ['insertInventoryCountRequest']),
    checkError(){
      if(!this.inventorycount.counttype){
        this.error = 'counttype';
        return false;
      }
      if(!this.inventorycount.countdate){
        this.error = 'countdate';
        return false;
      }
      if(!this.inventorycount.locationid){
        this.error = 'locationid';
        return false;
      }
      this.error = null;
      this.step = 2;
      return true;
    },
    addTransaction(){
      this.isAddTransaction = false;
      if(this.add_transaction.itemid==null || (this.add_transaction.itemqty==null && this.add_transaction.itempcs==null)) return;
      let index = this.transactions.findIndex((trans) => trans.itemid == this.add_transaction.itemid);
      if(index==-1){
        let trans = this.addItem(this.add_transaction);
        this.transactions.push(trans);
      }
      else {
        let trans = this.editItem(this.add_transaction);
        this.transactions.splice(index, 1, trans);
      }
      this.clearTransaction();
    },
    addItem(transaction){
      let item = this.items.find(item=>item._id == transaction.itemid);
      let convert = item.itemconvert!=null ? item.itemconvert : 1;
      let update = {
        id: Math.floor(Math.random() * Math.pow(10, 10)),
        itemid: item._id,
        itemimage: item.itemimage, 
        itemname: item.itemname,
        itemcost: item.itemcost,
        itemquantity: parseFloat(transaction.itemqty) + parseFloat(1/convert * transaction.itempcs)
      }
      let result = Object.assign({}, transaction, update);
      return result;
    },
    editTransactionDialog(item){
      this.edit_transaction = Object.assign({}, item);
      this.isEditTransaction = true;
    },
    editTransaction(){
      this.isEditTransaction = false;
      let index = this.transactions.findIndex((trans) => trans.id == this.edit_transaction.id);
      let trans = this.editItem(this.edit_transaction);
      this.transactions.splice(index, 1, trans);
      this.edit_transaction = {};
    },
    editItem(transaction){
      let item = this.items.find(item=>item._id == transaction.itemid);
      let convert = item.itemconvert!=null ? item.itemconvert : 1;
      let update = {
        id: Math.floor(Math.random() * Math.pow(10, 10)),
        itemid: item._id,
        itemimage: item.itemimage, 
        itemname: item.itemname,
        itemcost: item.itemcost,
        itemquantity: parseFloat(transaction.itemqty) + parseFloat(1/convert * transaction.itempcs)
      }
      let result = Object.assign({}, transaction, update);
      return result;
    },
    clearTransaction(){
      let brandid = this.add_transaction.brandid;
      this.add_transaction = Object.assign({}, {brandid: brandid});
    },
    async insertInventoryCount() {
      let payload = {order: this.inventorycount, transactions: this.transactions};
      console.log(payload);
      await this.insertInventoryCountRequest(payload);
      router.push('/inventorycount/list');
    },
    deleteTransaction(item){
      let index = this.transactions.findIndex(i=>i.id==item.id);
      if(index!=-1) this.transactions.splice(index,1);
    },
  },

  async created () {
    if(this.brands.length==0) await this.getBrandsRequest();
    if(this.items.length==0) await this.getItemsRequest();
    if(this.locations.length==0) await this.getLocationsRequest();
  }
}
</script>

<style src="./Add.scss" lang="scss"></style>
